import { t } from "i18next";
import moment from "moment/moment";
import { EsgLabel, FormInput, FormSelect } from "../../../../components/Forms";
import * as React from "react";
import { Box, Flex, useBreakpointValue } from "@chakra-ui/react";

export const OTHER_OPTION = "OTHER_OPTION";

export const LABEL_TYPES = Object.freeze({
  "ESG_LABEL": "ESG_LABEL",
  "STANDARD": "STANDARD"
});

function FinancialYearEndMonthSelector({ labelType, formState, register, watch, setValue }) {
  const containerFlow = useBreakpointValue({
    lg: "row",
    base: "column"
  });

  const financialYearEndMonthValue = watch("financialYearEndMonth");
  const otherClarificationValue = watch("otherClarification");

  const financialYearEndMonthSelector = register("financialYearEndMonth", {
    required: t("supplierQuestionnaire.general.requiredFiled")
  });

  return (
    <Flex gap={8} flexFlow={containerFlow}>
      <Box>
        {labelType === LABEL_TYPES.ESG_LABEL && (
          <EsgLabel text={`${t("supplierQuestionnaire.page.financialYearEnd")} *`} />
        )}

        <FormSelect
          {...financialYearEndMonthSelector}
          label={labelType === LABEL_TYPES.STANDARD ?
            `${t("supplierQuestionnaire.page.financialYearEnd")} *` : null}
          placeholder=" "
          errors={formState.errors}
          maxInlineSize={{ base: "full", lg: "sm" }}
          onChange={(e) => {
            financialYearEndMonthSelector.onChange(e);
            if (e.target.value !== OTHER_OPTION && otherClarificationValue !== null) {
              setValue("otherClarification", null);
            }
          }}
        >
          {moment.months().map(month =>
            <option key={month} value={month}>
              {month}
            </option>
          )}
          <option value={OTHER_OPTION}>
            {t("supplierQuestionnaire.page.otherOption")}
          </option>
        </FormSelect>
      </Box>

      {financialYearEndMonthValue === OTHER_OPTION ?
        <Box>
          {labelType === LABEL_TYPES.ESG_LABEL && (
            <EsgLabel text={`${t("supplierQuestionnaire.page.otherClarification")} *`} />
          )}
          <FormInput
            label={labelType === LABEL_TYPES.STANDARD ?
              `${t("supplierQuestionnaire.page.otherClarification")} *` : null}
            type="text"
            errors={formState.errors}
            {...register("otherClarification", {
              required: financialYearEndMonthValue === OTHER_OPTION ?
                t("supplierQuestionnaire.general.requiredFiled") : false
            })}
          />
        </Box> : null
      }
    </Flex>
  );
}

export default FinancialYearEndMonthSelector;